import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-choice-prod-price-grp',
  templateUrl: './choice-prod-price-grp.component.html',
  styleUrls: ['./choice-prod-price-grp.component.css']
})
export class ChoiceProdPriceGrpComponent implements OnInit {
    public choiceProdPriceGrpKeyno: string;

    prodIdChoice;

    public colourGroupButtons: FormButton[] = [{ id: 'list', icon: 'fa fa-bars', type: 'primary', goto: 'colorgrps' }];

    public colourGroupButtonsExpanded: FormButton[] = [
        { id: 'list', icon: 'fa fa-bars', type: 'primary', goto: 'colorgrps' },
        { id: 'goto', icon: 'fa fa-chevron-right', type: 'primary', goto: 'colorgrpmenu', gotoParms: () => this.edit!.colorgrp_id ?? '' }
    ];

    public edit?: Edit;

    public selectListColourGroups: Item[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.choiceProdPriceGrpKeyno = this.stateService.getStateParams()['choiceprodpricegrp_keyono'];
        this.prodIdChoice = this.stateService.getStateParams()['prod_id_choice'];
    }

    private async loadEdit() {
        if (!!this.choiceProdPriceGrpKeyno && !!this.prodIdChoice) {
            this.edit = (await this.datatask.Post(1201, {
                choiceprodpricegrp_keyono: this.choiceProdPriceGrpKeyno,
                prod_id_choice: this.prodIdChoice
            }))[0];
        }
    }

    private async loadColourGroups() {
        this.selectListColourGroups = await this.datatask.Post(1199);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1202, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(1203, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadColourGroups();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    choiceprodpricegrp_keyono: string;
    prod_id_choice: string;
    prod_name_choice: string;
    colorgrp_id: string;
    prod_keyno_choice: string;
}
